/* 🤖 this file was generated by svg-to-ts */
export const siriusPaperclipHorizontal: {
  name: 'paperclip_horizontal';
  data: string;
} = {
  name: 'paperclip_horizontal',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 7.5a.75.75 0 0 1 .75-.75H18a5.25 5.25 0 0 1 0 10.5H4.313c-2.048 0-3.677-1.697-3.677-3.75s1.629-3.75 3.677-3.75h13.5a2.25 2.25 0 1 1 0 4.5h-10.5a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 0 0-1.5h-13.5c-1.185 0-2.177.99-2.177 2.25s.992 2.25 2.177 2.25H18a3.75 3.75 0 0 0 0-7.5H7.5a.75.75 0 0 1-.75-.75Z" fill="currentColor"/></svg>`
};
